import { Box, chakra, Flex, shouldForwardProp, Text } from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { COMMON_WEB_PATH } from '../../constant';
import useLongMachineSetting from '@/hook/useLongMachineSetting';
import PrevButton from '../Modal/PrevButton';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const CommonModal = ({
  children,
  title,
  bgNone,
  onConfirm,
  otherComponents = <></>
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  // useEffect(() => {
  //   setKey((prev) => prev + 1); // 每次組件掛載時更新 key
  //   const timer = setTimeout(() => {
  //     setShowOverlay(false);
  //   }, 400);
  //   return () => clearTimeout(timer);
  // }, []);
  const { longMachinePaddingTop } = useLongMachineSetting();

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg={bgNone ? '' : 'rgba(0, 0, 0, 0.8)'}
      zIndex="9999"
      w="100%"
      h="100%"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
      pt={longMachinePaddingTop}
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="420px"
        minH="300px"
        bgImage={`url('${COMMON_WEB_PATH}/blue-layout/modal/hint_BG.webp')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position={'relative'}
        pl={6}
        pr={2}
        pt={'40px'}
      >
        <PrevButton onConfirm={onConfirm} />
        <Box
          display="flex"
          alignItems={'center'}
          justifyContent={'center'}
          alignSelf={'flex-start'}
          w="120px"
        >
          <Text
            fontWeight={'400'}
            fontSize="24px"
            textShadow={'0 0 1.5px white'}
          >
            {title || i18n('提醒')}
          </Text>
        </Box>
        {/* 隱形XX */}
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems={'center'}
          // position="relative"
          gap="20px"
          zIndex={2}
          w="100%"
          minH="250px"
          py="20px"
        >
          {children}
        </Flex>
      </ChakraBox>
    </Flex>
  );
};

export default CommonModal;
